import * as React from "react";
import { ui } from "../../../../dependencies";
export const EventIcon = (props) => {
    const classNames = ["rj-ev-list__event-icon"];
    props.isEmpty && classNames.push("rj-ev-list__event-icon--empty");
    props.tooltip && classNames.push("rj-ev-list__event-icon--tooltip");
    props.hideOnMobile && classNames.push("rj-ev-list__event-icon--hidden-on-mobile");
    return (React.createElement("div", Object.assign({ className: classNames.join(" "), onClick: props.onClick }, ui.TooltipApi.getInstance().setMessage(props.tooltip), { "data-uat": `div-ev-list-event-icon` }), props.children));
};
//# sourceMappingURL=EventIcon.js.map